import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const Header = styled(Box)`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  font-weight: bolder;
  padding: 0.25rem 1rem;
  height: 7vh;
  box-shadow: 0px 2px 0.4em rgba(0, 0, 32, 0.2);
  z-index: 1200 !important;
`;

export const Logo = styled.span<{ image: string }>`
  position: relative;
  height: 100%;
  width: 8rem;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-image: ${(props) => `url(${props.image})`};
`;
